import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";
import { CONTACT } from "@/content";
import { Reveal, Eyebrow, EASE } from "./Reveal";

export const Founder = () => {
  const { t } = useLang();
  const f = t.founder;
  return (
    <section id="fondator" className="section bg-surface" data-testid="founder-section">
      <div className="container-x grid items-center gap-14 lg:grid-cols-12">
        <motion.div initial="hide" whileInView="show" viewport={{ once: true, amount: 0.1 }} className="lg:col-span-5">
          <motion.div variants={{ hide: { clipPath: "inset(0 0 100% 0)" }, show: { clipPath: "inset(0 0 0% 0)" } }} transition={{ duration: 1.3, ease: EASE }} className="founder-frame group relative aspect-[4/5] overflow-hidden rounded-[28px] border border-line">
            <img src="/img/founder.webp" alt={CONTACT.founder} data-testid="founder-photo" className="absolute inset-0 h-full w-full scale-[1.02] object-cover object-[34%_center] saturate-[0.75] transition-[transform,filter] duration-[1.2s] ease-out group-hover:scale-105 group-hover:saturate-100" />
            <div className="absolute inset-0 bg-gradient-to-t from-bg via-bg/10 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 flex flex-wrap items-end justify-between gap-x-4 gap-y-1 p-7">
              <span className="whitespace-nowrap font-display text-xl font-medium text-ink">{CONTACT.founder}</span>
              <span className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.2em] text-gold">30+ yrs · Energy</span>
            </div>
          </motion.div>
        </motion.div>
        <div className="lg:col-span-7 lg:pl-8">
          <Reveal><Eyebrow>{f.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.05}><h2 className="mt-6 font-display text-5xl font-semibold tracking-[-0.03em] text-ink sm:text-7xl" data-testid="founder-name">{CONTACT.founder}</h2></Reveal>
          <Reveal delay={0.1}><p className="mt-3 font-serif text-2xl italic text-gold">{f.role}</p></Reveal>
          <Reveal delay={0.15}><p className="mt-8 max-w-xl text-lg leading-relaxed text-zinc-300" data-testid="founder-bio">{f.bio}</p></Reveal>
          <p className="mt-12 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{f.label}</p>
          <ul className="mt-4 border-t border-line">
            {f.career.map((c, i) => (
              <Reveal as="li" key={c} delay={i * 0.06} className="flex items-center justify-between border-b border-line py-4">
                <span className="font-display text-xl text-ink" data-testid={`founder-career-${i}`}>{c}</span>
                <span className="font-mono text-xs text-zinc-400">0{i + 1}</span>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
